module.exports = __webpack_public_path__ + "static/cabina-conductor---mampara-divisoria-fc39df929ab5313b7447d19066901237.jpg";